import React from 'react'
import { connect } from 'react-redux'
import { reduxForm, getFormValues, SubmissionError } from 'redux-form'
import { Breadcrumb, Button } from 'semantic-ui-react'
import { pascalCase } from 'change-case'
import { MainBodyContent } from 'components'
import { scrollToFirstValidateFailElement } from 'core/utilities'
import GeneralInformation from '../Form/GeneralInformation'
import ReferenceBG from '../Form/ReferenceBG'
import BankGuaranteeInformation from '../Form/BankGuaranteeInformation'
import ProjectManager from '../../../Form/ProjectManager'
import VendorContact from '../Form/VendorContact'
import Attachment from '../Form/Attachment'
import { bgVendorReportPath } from 'routes'
import { DocumentTypeContent } from './styled'
import { appLoading } from 'ducks/app'
import { createBankGuarantee } from 'ducks/bankGuarantee'
import { validateOriginalForm } from '../../../helper'

const CreateBankGuarantee = (props) => {
  const { valueForm, change, user } = props
  const [mainFormClickSave, setMainFormClickSave] = React.useState(false)
  const [submit, setSubmit] = React.useState(false)

  React.useEffect(() => {
    const isNullOrEmpty = (value) => {
      return (value === null || value === undefined || value === '')
    }

    if (isNullOrEmpty(valueForm.createType)) change('createType', props.createType)
    if (isNullOrEmpty(valueForm.requesterUser)) change('requesterUser', props.username)
    if (isNullOrEmpty(valueForm.documentDate)) change('documentDate', new Date())
    if (isNullOrEmpty(valueForm.noExpire)) change('noExpire', false)
    if (isNullOrEmpty(valueForm.location)) change('location', 'dtgo')
    if (isNullOrEmpty(valueForm.owner)) change('owner', 'vendor')
  }, [])

  React.useEffect(() => {
    if (user.isFinance !== undefined && user.isFinance !== null && user.isFinance === false) {
      props.history.push(bgVendorReportPath)
    }
  }, [user])

  const onSubmitCreateForm = (values) => {
    if (mainFormClickSave) {
      const { createBankGuarantee, history, appLoading } = props

      var errors = validateOriginalForm(values)

      if (Object.keys(errors).length) {
        scrollToFirstValidateFailElement(errors)
        setMainFormClickSave(false)
        throw new SubmissionError(errors)
      } else {
        setMainFormClickSave(false)
        createBankGuarantee(values, submit, history, appLoading)
      }
    }
  }
  
  return (
    <MainBodyContent 
      headerTitle='Bank Guarantee - Create'
      breadcrumbs={
        <Breadcrumb 
          icon='right angle' 
          sections={
            [
              { key: 'BG', content: 'Bank Guarantee', link: true, onClick: () => props.history.push(bgVendorReportPath) },
              { key: 'BGCreate', content: 'Create', active: true }
            ]
          }
        />
      }
      accessoriesHeader= {
        <div className='cardHeaderActions'>
        </div>
      }
    >
      <form onSubmit={props.handleSubmit((values) => onSubmitCreateForm(values))}>
        <DocumentTypeContent>Document Type : {pascalCase(valueForm.createType)}</DocumentTypeContent>
        <GeneralInformation valueForm={valueForm} change={change} />
        <ReferenceBG valueForm={valueForm} change={change} />
        <BankGuaranteeInformation valueForm={valueForm} change={change} />
        <ProjectManager />
        <VendorContact change={change} formName='formBankGuarantee' />
        <Attachment valueForm={valueForm} change={change} />
        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '10px' }}>
          <Button
            type='submit'
            content='Save'
            icon='save'
            labelPosition='right'
            style={{ marginRight: '5px' }}
            onClick={() => {
              setMainFormClickSave(true)
              setSubmit(false)
            }}
          />
          <Button
            type='submit'
            content='Save & Submit'
            color='blue'
            icon='save'
            labelPosition='right'
            style={{ marginRight: '5px' }}
            onClick={() => {
              setMainFormClickSave(true)
              setSubmit(true)
            }}
          />
        </div>
      </form>
    </MainBodyContent>
  )
}

const mapStateToProps = (state, props) => {
  const user = state.authen.user || {}
  const username = state.authen.user ? state.authen.user.username ? state.authen.user.username : '' : ''
  const vf = getFormValues('formBankGuarantee')(state) || {}
  const type = props.match.params.type || ''

  return ({
    user,
    username,
    valueForm: vf,
    createType: type
  })
}

const mapDispatchToProps = {
  appLoading,
  createBankGuarantee
}

const validate = (values) => {
  let errors = validateOriginalForm(values)

  return errors
}

const CreateBankGuaranteeForm = reduxForm({
  form: 'formBankGuarantee',
  enableReinitialize: false,
  onSubmitFail: scrollToFirstValidateFailElement,
  validate,
})(CreateBankGuarantee)

export default connect(mapStateToProps, mapDispatchToProps)(CreateBankGuaranteeForm)
